module.exports = __webpack_public_path__ + "static/media/Lettuce.1b12298e.png";